export default {
  methods: [],
  loading: false,
  error: null,
};
